import { FC, useState } from 'react';

import classNames from 'classnames';

import { MacCardList } from '../../mac-card-list';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { setMacSelected } from '../../../store/mac.slice';

import { MacCardsSelected } from './mac-card-selected';

export interface IMacCardsClientProps {
  /** Идентификатор участника — выбор карт привязывается к нему (разделение при нескольких клиентах) */
  participantIdentity?: string;
  /** Групповая терапия: отправить выбор по data channel (вместо socket) */
  sendMacSelectCards?: (result: Array<{ id: number; img: string; selected: boolean }>) => void;
  /** Групповая терапия: 6 столбцов в сетке карт */
  isGroupTherapy?: boolean;
}

type ViewMode = 'own' | 'shared';

export const MacCardsClient: FC<IMacCardsClientProps> = ({
  participantIdentity,
  sendMacSelectCards,
  isGroupTherapy,
}) => {
  const dec = useAppSelector((state) => state.macStateSlice.currentDec);
  const selectedCards = useAppSelector((state) => state.macStateSlice.selected);
  const sharedView = useAppSelector((state) => state.macStateSlice.sharedView);
  const dispatch = useAppDispatch();

  const [viewMode, setViewMode] = useState<ViewMode>('own');

  if (!isGroupTherapy) {
    return (
      <div
        id="ClentMC"
        className={classNames('h-full w-full flex flex-row pr-[0.25rem]', {
          'lg:min-w-[600px] md:min-w-[400px]': selectedCards.length <= 0,
        })}
      >
        {selectedCards.length > 0 ? (
          <MacCardsSelected selectedCards={selectedCards} />
        ) : (
          <MacCardList
            cards={dec}
            selectedCards={selectedCards}
            setSelectedCards={(s) => {
              dispatch(setMacSelected(s));
            }}
            onSubmitViaDataChannel={sendMacSelectCards}
          />
        )}
      </div>
    );
  }

  const hasShared = Boolean(sharedView && sharedView.cards.length > 0);
  const showToggle = selectedCards.length > 0 && hasShared;
  const activeCards = viewMode === 'shared' && sharedView ? sharedView.cards : selectedCards;
  const sharedLabel = sharedView?.participantLabel
    ? `Карты участника ${sharedView.participantLabel}`
    : 'Карты на общем экране';

  return (
    <div
      id="ClentMC"
      className="h-full w-full min-h-0 flex flex-col bg-white rounded-[5px] md:rounded-[15px] overflow-hidden"
    >
      {selectedCards.length > 0 ? (
        <>
          {showToggle && (
            <div className="flex shrink-0 px-4 pt-3 pb-1 gap-2">
              <button
                type="button"
                onClick={() => setViewMode('own')}
                className={classNames(
                  'px-4 py-1.5 rounded-full text-sm font-medium font-manrope transition-colors',
                  viewMode === 'own'
                    ? 'bg-[#C00000] text-white'
                    : 'bg-[#E5E5E5] text-[#2C3038] hover:bg-[#D5D5D5]',
                )}
              >
                Мои карты
              </button>
              <button
                type="button"
                onClick={() => setViewMode('shared')}
                className={classNames(
                  'px-4 py-1.5 rounded-full text-sm font-medium font-manrope transition-colors',
                  viewMode === 'shared'
                    ? 'bg-[#C00000] text-white'
                    : 'bg-[#E5E5E5] text-[#2C3038] hover:bg-[#D5D5D5]',
                )}
              >
                {sharedLabel}
              </button>
            </div>
          )}
          <div className="flex-1 min-h-0 p-4 overflow-hidden flex flex-col">
            <MacCardsSelected
              selectedCards={activeCards}
              isGroupTherapy={isGroupTherapy}
              fillContainerHeight={isGroupTherapy}
            />
          </div>
        </>
      ) : (
        <MacCardList
          cards={dec}
          selectedCards={selectedCards}
          setSelectedCards={(s) => {
            dispatch(setMacSelected(s));
          }}
          participantIdentity={participantIdentity}
          onSubmitViaDataChannel={sendMacSelectCards}
          isGroupTherapy={isGroupTherapy}
        />
      )}
    </div>
  );
};
